import React, {useEffect} from "react";

import BannerSection from '../../shared/components/BannerSection/BannerSection';
import unsubscribeBannerImg from '../../utils/assets/cancelService/dog-in-customer-service.png';
import NavegationInfo from "../../shared/components/NavegationInfo/NavegationInfo";
import Cancelation from '../components/Cancelation/Cancelation';

 

const CancelService = props => {
     const legendInfo =
     {
         cardTitle: "Do you have a cancel request?",
         cardButtonText: "",
         lengendBackground: unsubscribeBannerImg
     }
     useEffect(()=>{
        window.scrollTo(0, 0);
    }, [])
    return (
        <React.Fragment>
            <BannerSection props={legendInfo}/>
            <NavegationInfo page="Cancel service"/>
            <Cancelation/>
            
            
        </React.Fragment>
    );
};

export default CancelService;